<app-abstract-notification-card
  (closeEvent)="onCloseClickedHandler()"
  [notification]="jobNotification"
  [notificationIcon]="notificationIcon"
>
  <div notification-content>
    @if (jobNotification.statusPendingFlag) {
      <div class="status-pending">
        <mat-progress-bar class="detail-progress-bar mb-8 mt-8 mr-16 whole-width" mode="indeterminate"></mat-progress-bar>
        <span class="notification-message">{{ pendingMessage }}</span>
      </div>
    }
    @if (jobNotification.statusSucceedFlag) {
      <div class="primary-fg fxl-row fxla-space-between-center">
        <span class="notification-message">{{ succeedMessage }}</span>
        <div>
          <ng-content select="[notification-action-button]"></ng-content>
        </div>
      </div>
    }
    @if (jobNotification.statusFailedFlag) {
      <div class="notification-content warn-fg">
        <span class="notification-message">Erreur imprévue. Veuillez recommencer.</span>
      </div>
    }
    @if (jobNotification.statusNothingToDoFlag) {
      <div class="notification-content warn-fg">
        <span class="notification-message">Documents inexistants. Veuillez rafraîchir la liste.</span>
      </div>
    }
  </div>
</app-abstract-notification-card>
